export default __webpack_public_path__ + "static/media/Interface.752221c3.png";